module.exports = __webpack_public_path__ + "img/05_1_2_2.122df63b.png";